export default "/_next/static/chunks/fonts/TheinhardtRegular-bdd1fef5e218a8946879d9e04242d288.woff";